export enum ItemListEnum {
    Label,
    Route,
    Event,
    Separator,
    Links
}